import styled from 'styled-components'
import React from 'react';

import Icon from '../reusable/Icon'


const Alert = ({ text, onClick }) => {
  
  return(
    <Button onClick={onClick}>
      {text}
      <Icon icon="arrRight" width={25} height={12} margin="0px 0px 0px 16px" />
    </Button>
  )
}

export default Alert


const Button = styled.button(props => ({
  color:"#000",
  background:"#fff",
  paddingLeft:0,
  display:"flex",
  cursor:"pointer",
  whiteSpace:"no-break",
  alignItems:"center",
  transition:"0.2s ease-in-out",
  height:64,
  border:"none",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "21px",
  outline:"none",
  paddingRight:40,
  ":hover":{
    color:"#fff",
    background:"#000",
    paddingLeft:40,
    marginRight:40,
  },
}));
